"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montottone": {
    "c9c9272b": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-eschito": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6555c429": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "skipSearch": false
    }],
    "forche-di-tenna": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d49b4fb": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "skipSearch": false
    }],
    "monteroso": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63427f64": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "skipSearch": false
    }],
    "pisciarello": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46a60d31": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1a93b9a": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-martire": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e643f97": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "skipSearch": false
    }],
    "trescio": [{
      "hkey": "7679864b",
      "slug": "montottone",
      "name": "Montottone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;